import {Component, EventEmitter, Input, Output} from '@angular/core';
import { NgxLoadingModule } from 'ngx-loading';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-form-buttons',
    templateUrl: './form-buttons.component.html',
    styleUrls: ['./form-buttons.component.scss'],
    standalone: true,
    imports: [NgIf, FontAwesomeModule, RouterLink, NgxLoadingModule]
})
export class FormButtonsComponent {

  constructor() {
  }

  @Input()
  public visible = true;

  @Input()
  public busy = false;

  @Input()
  public resetButtonEnabled = true;

  @Input()
  public altLinkEnabled = false;

  @Input()
  public altLink = '';

  @Input()
  public altLinkCaption = '';

  @Input()
  public altButtonEnabled = false;

  @Output()
  public altButtonAction = new EventEmitter<void>();

  @Input()
  public altButtonCaption = '';

  @Input()
  public saveCaption = 'opslaan';

  @Input()
  public errorMessage = '';

  @Input()
  public disabled = false;

  @Input()
  public success = false;

  @Input()
  public updateButtonState = true;

  @Input()
  public buttonClasses = '';

  @Output()
  public reset = new EventEmitter<void>();

  public resetData(): boolean {
    this.reset.emit();
    return false;
  }

}
